import { Trans, useTranslation } from 'react-i18next';

import Accordion from 'components/global/Accordion';
import Typography from 'components/global/Typography';

import * as S from './SalesChannelDetail.styled';

const SalesChannelFaq = ({ faqs }) => {
	const { t } = useTranslation();
	return (
		<S.FaqContainer>
			{faqs.map((faq, index) => (
				<Accordion key={index} header={t(`${faq}.question`)} defaultVisible={index === 0}>
					<Typography noWrap>
						<Trans i18nKey={`${faq}.answer`} />
					</Typography>
				</Accordion>
			))}
		</S.FaqContainer>
	);
};

export default SalesChannelFaq;
